import { render, staticRenderFns } from "./ServiciosImpagosListaItem.vue?vue&type=template&id=97225442&"
import script from "./ServiciosImpagosListaItem.vue?vue&type=script&lang=js&"
export * from "./ServiciosImpagosListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports